/** Cambiar a `true` para volver a mostrar el modal del Mundial al ingresar al CRM. */
export const MUNDIAL_WELCOME_ENABLED = false;

export const MUNDIAL_WELCOME_PENDING_KEY = 'pulse:mundial-welcome-pending';

export function markMundialWelcomePending() {
  try {
    sessionStorage.setItem(MUNDIAL_WELCOME_PENDING_KEY, '1');
  } catch {
    // ignore private mode
  }
}

export function consumeMundialWelcomePending() {
  try {
    const pending = sessionStorage.getItem(MUNDIAL_WELCOME_PENDING_KEY) === '1';
    if (pending) sessionStorage.removeItem(MUNDIAL_WELCOME_PENDING_KEY);
    return pending;
  } catch {
    return false;
  }
}

export function peekMundialWelcomePending() {
  try {
    return sessionStorage.getItem(MUNDIAL_WELCOME_PENDING_KEY) === '1';
  } catch {
    return false;
  }
}
